import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem, size } from 'polished'

import { type SeverityType } from '@Types/severity'
import { getColorBySeverity } from '@Utils/severity'

export const container = css({
  display: 'flex',
})

export const icon = (theme: Theme): SerializedStyles =>
  css({
    marginRight: theme.spacing(0),
    ...size(rem(16)),
  })

export const description = (severity: SeverityType, theme: Theme): SerializedStyles =>
  css({
    color: getColorBySeverity(theme, severity),
  })

export const actionWrapper = (theme: Theme): SerializedStyles =>
  css({
    marginBottom: `-${theme.spacing(2)}`,
    textAlign: 'center',
  })
